import { render, staticRenderFns } from "./ExtendOtherNutrientsManganese.vue?vue&type=template&id=39a93ef0&scoped=true"
import script from "./ExtendOtherNutrientsManganese.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsManganese.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsManganese.vue?vue&type=style&index=0&id=39a93ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a93ef0",
  null
  
)

export default component.exports